import { render } from "./changestorage.vue?vue&type=template&id=c98e3e28&scoped=true"
import script from "./changestorage.vue?vue&type=script&lang=js"
export * from "./changestorage.vue?vue&type=script&lang=js"

import "./changestorage.vue?vue&type=style&index=0&id=c98e3e28&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98e3e28"]])

export default __exports__